import { BRIDGE_NAME } from "../bridgeConstants";

export const listenForParentPostMessages = () => {
  window.addEventListener("message", message => {
    const { err, data, funcName, body } = message.data;

    if (funcName === "callbackHandler") {
      window[BRIDGE_NAME](err, undefined, data, body);
    }
  });
};
const postMessage = data => {
  window.parent.postMessage(data, "*");
};
export const updateParentUrl = url => {
  postMessage({
    funcName: "updateUrl",
    data: url.replace("/support/web-faqs", ""),
  });
};
export const webBridge = () => {
  listenForParentPostMessages();

  window.NativeStore = {
    getString(data) {
      postMessage({ funcName: "getString", data });
    },
    setString(tokenName, token) {
      postMessage({
        funcName: "setString",
        data: {
          tokenName,
          token,
        },
      });
    },
  };
  window.Freshbot = {
    getToken(context, body) {
      postMessage({
        funcName: "getToken",
        data: { context, body },
      });
    },
    logEvent(name, category, data) {
      postMessage({
        funcName: "logEvent",
        data: {
          name,
          category,
          data,
        },
      });
    },
  };
};
